<script lang="ts">
    import LoadingSpinner from '@amp/web-app-components/src/components/LoadingSpinner/LoadingSpinner.svelte';
    import { intersectionObserver } from '@amp/web-app-components/src/actions/intersection-observer';

    type T = $$Generic;

    export let items: T[] = [];
    export let hasMore: boolean = true;
    export let isLoading: boolean = false;
    export let loadMore: () => Promise<T[] | void>;

    let loadedItems: T[] = [];
    $: allItems = [...items, ...loadedItems];

    let _loading = false;
    $: loading = isLoading || _loading;

    async function loadingVisible(isVisible: boolean) {
        if (isVisible && !loading) {
            _loading = true;
            try {
                let moreItems = await loadMore();
                if (moreItems) {
                    loadedItems = [...loadedItems, ...moreItems];
                }
            } finally {
                _loading = false;
            }
        }
    }
</script>

{#each allItems as item, index}
    <slot {item} {index} />
{/each}
{#if hasMore}
    <div
        class="infinite-scroll-spinner"
        data-testId="infinite-scroll-spinner"
        use:intersectionObserver={{ callback: loadingVisible }}
        aria-busy={loading}
        aria-live="polite"
    >
        {#if loading}
            <LoadingSpinner delay={200} inset={true} />
        {/if}
    </div>
{/if}

<style lang="scss">
    .infinite-scroll-spinner {
        margin-top: 10px;
        margin-bottom: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
        height: 16px;
        width: 100%;
        z-index: var(--z-default);

        @media (--small) {
            height: 52px;
        }

        @media (--range-xsmall-down) {
            padding: 0;
        }
    }
</style>
